import React, { useState } from 'react';

const C = {
  primary: '#0F6E56', gold: '#91600C', border: '#E3E1D9',
  muted: '#5F5E5A', danger: '#C0392B',
};

const API = '/api/freelance';

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

/**
 * Pending order ki payment.
 *
 * Order ban jata tha (cart se, ya custom offer accept karne par) magar
 * payment ka koi rasta hi nahi tha - order hamesha 'pending' par atka
 * rehta tha. Ye button seedha Pi ki payment kholta hai.
 */
export default function PayOrderButton({ order, onPaid }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  if (!order || order.status !== 'pending') return null;

  const price = order.price_pi;

  const pay = async () => {
    if (!window.Pi) {
      setMsg('Please open PenFlow in the Pi Browser to pay.');
      return;
    }

    setBusy(true);
    setMsg('');

    try {
      // Purani adhoori payment pehle nipta do - warna Pi nayi shuru
      // hi nahi karne deta aur user phans jata hai.
      const onIncomplete = (payment) => {
        const md = (payment && payment.metadata) || {};
        if (!md.order_id) return;
        const tx = payment.transaction && payment.transaction.txid;
        fetch(`${API}/orders/${md.order_id}/${tx ? 'complete' : 'approve'}/`, {
          method: 'POST',
          headers: authHeaders(),
          body: JSON.stringify(tx
            ? { payment_id: payment.identifier, txid: tx }
            : { payment_id: payment.identifier }),
        }).catch(() => {});
      };

      await window.Pi.authenticate(['username', 'payments'], onIncomplete);

      window.Pi.createPayment(
        {
          amount: price,
          memo: `Order ${order.tracking_code || order.id}`.slice(0, 100),
          metadata: { type: 'freelance_order', order_id: order.id },
        },
        {
          onReadyForServerApproval: (paymentId) => {
            fetch(`${API}/orders/${order.id}/approve/`, {
              method: 'POST',
              headers: authHeaders(),
              body: JSON.stringify({ payment_id: paymentId }),
            });
          },
          onReadyForServerCompletion: (paymentId, txid) => {
            fetch(`${API}/orders/${order.id}/complete/`, {
              method: 'POST',
              headers: authHeaders(),
              body: JSON.stringify({ payment_id: paymentId, txid }),
            })
              .then(() => {
                setMsg('Paid. The freelancer can start now.');
                setBusy(false);
                if (onPaid) onPaid();
              })
              .catch(() => {
                setMsg('Payment reached Pi but the order did not activate. Please contact support.');
                setBusy(false);
              });
          },
          onCancel: () => {
            setMsg('Payment cancelled. The order is still here — you can pay any time.');
            setBusy(false);
          },
          onError: () => {
            setMsg('Payment failed. Please try again.');
            setBusy(false);
          },
        }
      );
    } catch (e) {
      setMsg(e.message || 'Something went wrong.');
      setBusy(false);
    }
  };

  return (
    <div style={{ marginTop: 8, padding: '9px 11px', borderRadius: 8,
                  background: '#FDF0DD', border: `1px solid ${C.gold}` }}>
      <p style={{ margin: '0 0 6px', fontSize: 12, color: C.gold, fontWeight: 700 }}>
        {'\u23F3'} Waiting for payment — {price} Pi
      </p>
      <p style={{ margin: '0 0 8px', fontSize: 11, color: C.muted, lineHeight: 1.5 }}>
        The freelancer starts once this is paid. Your Pi is held safely until you accept the work.
      </p>

      <button
        onClick={pay}
        disabled={busy}
        style={{
          fontSize: 13, fontWeight: 700, padding: '9px 20px', border: 'none',
          borderRadius: 8, background: busy ? '#B4B2A9' : C.primary,
          color: '#fff', cursor: busy ? 'wait' : 'pointer',
        }}
      >
        {busy ? 'Opening Pi…' : `\u{1F4B3} Pay ${price} Pi`}
      </button>

      {msg && (
        <p style={{ margin: '7px 0 0', fontSize: 11.5,
                    color: msg.startsWith('Paid') ? C.primary : C.danger }}>
          {msg}
        </p>
      )}
    </div>
  );
}
